/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import axios from 'axios';
import utils from '../../../common/utils';
import env from '../../../common/env';
import { EVG_V1_VERSION } from '../constants/ServiceConstants';

const SYS_TO_SYS_EXPIRY = 5;

export default class TokenService {
  constructor() {
    this.sys2sysExpiry = 0;
    this.sys2sysToken = null;
  }

  static async getSys2sysToken(forceRefresh) {
    if (!forceRefresh && this.sys2sysExpiry - SYS_TO_SYS_EXPIRY * 60 * 1000 > Date.now()) {
      return this.sys2sysToken;
    }

    try {
      const intToken = utils.getToken();
      const response = await axios.get(`${env.EVG_SVC_URL}/${EVG_V1_VERSION}/getpitoken`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${intToken}`
        }
      });
      if (response && response.data && response.data?.data) {
        const { token, expiresIn } = response.data.data;
        this.sys2sysExpiry = expiresIn;
        this.sys2sysToken = token;
      }
      return this.sys2sysToken;
    } catch (err) {
      return err;
    }
  }
}
